import React, { useState, useEffect} from 'react';
import '../App.css';
import '../css/RecordEdit.css';

import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import Input from '@mui/material/Input';
import TextField from '@mui/material/TextField';

import Checkbox from '@mui/material/Checkbox'
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import { MuiTelInput } from 'mui-tel-input'
import MakePhoneCall from './MakePhoneCall'
import { useSelector, useDispatch } from 'react-redux';
import {setSelectedTab } from '../slices/uiSlice';

function PhoneField(props) {
  const [phonenos, setPhoneNos] = useState([])
  const [dialphone, setDialPhone] = useState(null)
  const [opendialphone,setOpenDialPhone] = useState(false)
  const [phonefield,setPhoneField]=useState()

  useEffect(()=> {
    props.cols.filter(item=> item.type==='phone' && item.fldSection ==='hide').map(item => {
      const number = props.data[item.field]
      if(number !== null && typeof number !== 'undefined' && number > "")
        setPhoneNos((prevPhones) => [...prevPhones, {field: item.field, type:`${item.headerName}`, number, notes: item.note, tps: false, dnc: false, nnr: false }])
      return null
    })
  },[props.time,props.cols, props.data])

  const openClickToDial = (phoneno, field) => {
    setDialPhone(phoneno)
    setOpenDialPhone(true)
    setPhoneField(field)
    // dispatch(setRowData(props.data))

  }
  const formatPhone = (phonein) => {
    if(typeof phonein === "undefined" || phonein === null)
      return "";
    let phone = (phonein??"").replaceAll(" ", "")
    if(phone==="") return "";
    if(phone.substr(0,1) === "0")
      return `+44${phone.substr(1)}`
    return `+44${phone}`;
  }

    let phonectrls =  <></>;
    if(typeof phonenos !== "undefined" && typeof props.field !== 'undefined' && Array.isArray(phonenos)) {
      phonectrls = phonenos.map((phitem,index) =>
        <div  key={`phnflddiv_${props.uid}_${index}` } className='fielddivider'>
          <div className='muiphonecontainer' >
            <MuiTelInput
              style={{fontSize: '8pt!important'}}
              defaultCountry="GB"
              label={`Phone ${index+1}`}
              id={`phone_${props.uid}_${index}`}
              name={phitem.field}
              type='tel'
              value={formatPhone(phitem.number??'')}
              variant="standard"
              readOnly={!props.field.editable}
              inputProps={{style: {fontSize: '8pt', width: '500px'}}} ƒ
            />
          </div>
          <div style={{display: 'inline-block', width: '200px!mportant', fontSize: '8pt', verticalAlign: 'top'}} >
            <Select id={`phonetype_${props.uid}_${index}`} defaultValue={phitem.type} style={{fontSize: '8pt',marginRight: '5px'}} >
              <MenuItem value="" >Select</MenuItem>
              <MenuItem value='CC Main Phone' disabled>CC Lead Main Number</MenuItem>
              <MenuItem value='CC Alt Phone' disabled >CC Lead Alt Number</MenuItem>
              <MenuItem value='CC Mobile' disabled >CC Lead Mobile Number</MenuItem>
              <MenuItem value='Home'>Home</MenuItem>
              <MenuItem value='Office'>Office</MenuItem>
              <MenuItem value='Mobile'>Personal Mobile</MenuItem>
              <MenuItem value='WorkMobile'>Work Mobile</MenuItem>
              <MenuItem value='PA'>PA / Assitant</MenuItem>
              <MenuItem value='Accountant'>Accountant</MenuItem>

            </Select><br/>
            <div className="phnoptpouts" >
              <input id={`chktps_${props.uid}_${index}`} type='checkbox' defaultChecked={phitem.tps??false} className='chephncheckbox'  /><label  className="checkboxlabels" for={`chktps_${props.uid}_${index}`} >TPS&nbsp;&nbsp;</label>
              <input id={`chknnr_${props.uid}_${index}`} type='checkbox' defaultChecked={phitem.nnr??false} className='chephncheckbox'  /><label  className='checkboxlabels' for={`chknnr_${props.uid}_${index}`} >NNR&nbsp;&nbsp;</label>
              <input id={`chkdnc_${phitem.uid}_${index}`} type='checkbox' defaultChecked={phitem.dnc??false} className='chephncheckbox'  /><label  className='checkboxlabels' for={`chkdnc_${props.uid}_${index}}`} >DNC</label>
            </div>
          </div>
          <div style={{display: 'inline-block', width: '350px', fontSize: '8pt', verticalAlign: 'top'}} >
              Notes: <textarea className='phnnotes' row={2} cols={30} defaultValue={phitem.notes}></textarea>
          </div>
          <div style={{display: 'inline-block', width:'120px'}} >
            <Button variant="outlined" size="small" className='btn_dial' onClick={() => openClickToDial(formatPhone(phitem.number??''), phitem.field) }>
                Click To Dial
            </Button>
          </div>
        </div>
      )
    }
    return (
      <React.Fragment>
        {opendialphone && <MakePhoneCall open={opendialphone} phone={dialphone} field={phonefield} data={props.data} starttime={Date.now()} onClose={() => setOpenDialPhone(false)} /> }
        {phonectrls}
      </React.Fragment>)
}


function RecordEdit(props) {
  const [open, setOpen] = React.useState(false);
  const [data,setData]=useState(props.data)
  const auth = useSelector(state => state.auth)
  const dispatch = useDispatch();


  useEffect(()=> {
    async function LoadData() {
      // We used to use this for Loading Notes
    }
    if(!open) {
      console.log(`RecordEdit props.open set to ${props.open}`)
      setOpen(props.open)
      setData(props.data)
    }
    if(props.open && auth.token > "" && typeof props.data !== 'undefined' && props.data.id > "" )
      LoadData();
  },[props.open, props.data, auth.token, open]);


  const handleClose = () => {
    dispatch(setSelectedTab(0))
  };

  const handleUpdate = async () => {
    const newRow = JSON.parse(JSON.stringify(data))
    await props.onUpdate(newRow)
  }


  const updateField = ({target:{name, value}}) =>{
    //console.log(`updateField with ${name} ${value}`)
    setData( (prevData) => ( {...prevData,[name]: value} ));
  }


  const addTextField = (item, index) => {
    return (
      <div className='fielddivider' key={`txtfld_${index}_${Date.now()}`} >
            <TextField
              label={item.headerName}
              id={item.field}
              name={item.field}
              type='text'
              value={(typeof item.valueGetter==='undefined')?data[item.field]??'':item.valueGetter(data[item.field]??'') }
              onChange={updateField}
              variant="standard"
              sx={{
                input: {
                   "::before": {    // <----- Add this.
                      fontSize: '8pt',
                      color: 'red'
                   },
                   width: '500px',
                },

             }}
              inputProps={{style: {fontSize: '10pt', width: '500px'}}}
              disabled={!(item.editable??true)}
              size='medium'
            />
      </div>

    )
  }

  const addDateField = (item, index) => {
    return (
      <div key={`datefld_${(item.field??"").replaceAll(" ","").toLowerCase()}` } className='fielddivider'  >
      <InputLabel shrink={true} htmlFor={item.field} sx={{backgroundColor: 'white'}}>{item.headerName}&nbsp;</InputLabel>
      <Input
        label={item.headerName}
        id={item.field}
        name={item.field}
        type='date'
        value={data[item.field]??''}
        onChange={updateField}
        variant="standard"
        sx={{fontSize: '8pt'}}
        disabled={!(item.editable??true)}
      />
      </div>
    )
  }

  const updatePhoneData = (field, newdata) => {
    setData((prevData)=> (
        {...prevData,[field]: newdata}
      )
    )
  }

  const addPhoneField = (item, index) => {
    return (
      <PhoneField key={`phonefld_${index}_${Date.now()}`} time={Date.now()} cols={props.cols} data={data} field={item} uid={1} updateParent={updatePhoneData} />
    )
  }

  const addSelectField = (item, index) => {
    return (
      <div  key={`fld_${(item.field??"").replaceAll(" ","").toLowerCase()}_${index}_${Date.now()}` }  className='fielddivider' >

      <FormControl style={{ width: "100%", marginTop: 10, marginBottom: 5 }} size="small">
        <InputLabel shrink={true} htmlFor={item.field} sx={{backgroundColor: 'white'}}>{item.headerName}&nbsp;</InputLabel>
        <Select
          style={{ width: "90%"}}
          label={`lbl_${item.field}`}
          id={item.field}
          name={item.field}
          defaultValue={(data[item.field]??'').toUpperCase()}
          displayEmpty
          disabled={!(item.editable??true)}
          /*onChange={updateField}
          readOnly={!item.editable??false}*/
        >
        <MenuItem value="">
          <em>Select A Status</em>
        </MenuItem>
          {item.valueOptions.map((itema, index) => {
            return (
              <MenuItem key={`${item.field}_${index}`} value={itema.value} >
                {itema.label}
              </MenuItem>)

          })}
        </Select>
      </FormControl>
      </div>
    )
  }
  const addCheckBoxField = (item,index) => {
    return (
      <div  key={`chkfld_${(item.field??"").replaceAll(" ","").toLowerCase()}_${index}_${Date.now()}` }  className='fielddivider' >

      <FormControlLabel
      label={item.headerName}
      control={<Checkbox  id={item.field} defaultChecked={data[item.field]??false} disabled={!(item.editable??true)} />}
      />
      </div>
    )
  }

  const viewDirectors = (item) => {
    let dirs = []
    let showHTML = true;
    try {
      const dr = JSON.parse(data[item.field])
      for(const item of dr)
        dirs.push(item.toLowerCase().replace(/\b\w/g, s => s.toUpperCase()))
    }catch(err) {
      showHTML = false;
    }
    const text = dirs.join(", ")

    const html = (<><h4 style={{textAlign: 'left', marginBottom: 0, paddingBottom: '5px', padding: 0, marginTop: '5px'}}>Active Director / Offices</h4>
                    <ul style={{paddingTop: '10px', marginTop: 0}}>
                    {dirs.map((item,index) => (<li key={`directorli_${index}_${Date.now()}`} style={{fontSize: '10pt', verticalAlign: 'top',height: '24px!important', lineHeight: '20px!important'}}>{item}</li>))}
                    </ul>
                  </>
                  )
    if(showHTML)
        return html;
    return text;
  }



  const chooseConrol = (item, index) => {
    //console.log(`chooseControl => ${(item.type??'').toLowerCase()}`)
    if(item.field === "Directors")
      return viewDirectors(item, index);

    switch((item.type??'').toLowerCase()) {
      case 'phone':
        return addPhoneField(item,index)
      case 'string':
        return addTextField(item,index)
      case 'date':
        return addDateField(item,index)
      case 'boolean':
        return addCheckBoxField(item,index)
      case 'singleselect':
        return addSelectField(item,index)
      default:
        return addTextField(item,index);
    }

  }

  return (
    <div className='container' >
        <h4>View/Edit Lead</h4>
        <div id='content' className='content'>
          <p>
            Update the Lead and Press Update to Commit the update or Cancel to close without updating.<br/>
          </p><br/>

            <strong>Company Details</strong><br/>
            {props.cols.filter((item,index)=>item.fldSection==='company').map((item,index) => {
              return chooseConrol(item, index)
            })}
            <strong>Contact Details</strong><br/>
            {props.cols.filter(item=>item.fldSection==='contact' && (typeof item.isphone == 'undefined' || !item.isphone) ).map((item,index) => {
              return chooseConrol(item, index)
            })}
            <strong>Phone Numbers</strong><br/>
            {props.cols.filter(item=>item.isphone ||item.fldSection==='phone').map((item, index) => {
              let phitem = {...item,isphone: true, type: 'phone' }
              return addPhoneField(phitem, index);
            })}
            <br/><input type='button' className='addbtn' value='Add New Phone Number' />
            <br/><strong>Lead Details</strong>
            {props.cols.filter(item=>item.fldSection==='data').map((item, index) => {
              return chooseConrol(item, index)
            })}
            <br/><strong>Information / Status</strong>
            {props.cols.filter(item=>item.fldSection==='status').map((item, index) => {
              return chooseConrol(item, index)
            })}
        </div>
        <div id='buttons'>
            <Button variant="outlined" size='small' onClick={handleClose}>Cancel</Button>
            <Button variant="outlined" size='small' onClick={handleUpdate}>Update</Button><br/>
          </div>
      </div>
  );
}

export default RecordEdit